import { Group, Paper, Text, ThemeIcon } from "@mantine/core";
import { getNodeDetails, isMainAction, nodeWidth } from "../flowSettings";
import { useMemo } from "react";
import { useFlowStore } from "../../../../../../stores/WorkflowStore";
import EmailNodeBody from "./EmailNodeBody";
import LinkedinNodeBody from "./LinkedinNodeBody";
import SmvNodeBody from "./SmvNodeBody";
import NodeDeleter from "../components/NodeDeleter";
import NodeId from "./NodeId";
import { getOutgoers } from "reactflow";
import NodePlus from "./NodePlus";
import NodeSettings from "../components/NodeSettings";
import { modals } from "@mantine/modals";
import NodePanelMain from "../panel/NodePanelMain";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import Linker from "./event/Linker";
import LinkerOverlay from "../components/LinkerOverlay";
import { useCampaignStore } from "../../../../../../stores/CampaignStore";
import PreviewModal from "../../ai-flow/PreviewModal";

const ActionNode = ({ data, id, nodeDetail, xPos, yPos }) => {
  const lang = useLanguage((s) => s.language);
  const agentId = useCampaignStore((s) => s.agentId);
  const nodes = useFlowStore((s) => s.nodes);
  const edges = useFlowStore((s) => s.edges);
  const linking = useFlowStore((s) => s.linking);

  const outgoers = useMemo(() => {
    let n = nodes.find((x) => x.id === id);
    if (n) return getOutgoers(n, nodes, edges);
    return [];
  }, [id, nodes, edges]);

  const getAdditionalInfo = useMemo(() => {
    if (data?.actionType === "email") {
      return <EmailNodeBody node_id={id} data={data} xPos={xPos} yPos={yPos} />;
    }
    if (data?.actionType?.includes("linkedin") || data?.actionType === "sms") {
      return (
        <LinkedinNodeBody node_id={id} data={data} xPos={xPos} yPos={yPos} />
      );
    }
    if (data?.actionType === "smv") {
      return <SmvNodeBody node_id={id} data={data} xPos={xPos} yPos={yPos} />;
    }
    return null;
  }, [data, id, xPos, yPos]);

  const handleNodeClick = (e) => {
    if (agentId) {
      return modals.open({
        modalId: "node-preview",
        title: "Séquence",
        size: "100%",
        children: <PreviewModal clickedNode={{ id, data }} />,
      });
    }
    modals.open({
      modalId: "node-configs",
      title: lang.campaign.step_config_title,
      size: "xl",
      children: <NodePanelMain clickedNode={{ id, data }} />,
    });
  };

  const isError = useMemo(() => {
    if (
      data?.actionType === "email" ||
      data?.actionType === "linkedin_message"
    ) {
      return !data?.model_id || (!data?.integration_id && !data?.pool_id);
    }
    if (
      data?.actionType === "linkedin_invitation" ||
      data?.actionType === "linkedin_visit"
    ) {
      return !data?.integration_id && !data?.pool_id;
    }
    if (data?.actionType === "sms") {
      return !data?.model_id;
    }
    if (data?.actionType === "smv") {
      return !data?.model_id;
    }
  }, [data?.actionType, data?.integration_id, data?.model_id, data?.pool_id]);

  return (
    <Paper
      w={nodeWidth}
      withBorder
      className={"action-node action"}
      p={"xs"}
      pt={6}
      pb={4}
      pos={"relative"}
      // style={{
      //   borderColor: isError
      //     ? "var(--mantine-color-red-6)"
      //     : "#4664e2",
      // }}
      style={{
        borderColor: isError ? "var(--mantine-color-red-6)" : "#4664e2",
      }}
      radius={"lg"}
      my={"auto"}
      bg={"#fff"}
      px={"lg"}
      py={"md"}
    >
      <LinkerOverlay
        isEvent={data?.actionType === "event"}
        id={id}
        data={data}
        xPos={xPos}
        yPos={yPos}
        active={linking?.id === id}
      />
      <div onClick={handleNodeClick}>
        <Group justify="center">
          <ThemeIcon
            variant="filled"
            color={nodeDetail.color}
            size={"lg"}
            radius={"md"}
            mt={8}
          >
            {nodeDetail.icon}
          </ThemeIcon>
        </Group>
        <Text fz={"md"} ta={"center"} fw={"bold"} my={8}>
          {nodeDetail.label}
        </Text>

        <NodeDeleter
          actionType={data.actionType}
          id={id}
          source={data.source}
          outgoers={outgoers}
          disabled={data?.number_contacts > 0}
        />

        <NodeId id={id} />
      </div>

      {getAdditionalInfo ? <Group mt={4}>{getAdditionalInfo}</Group> : null}

      {useFlowStore.getState().initialId !== id && <NodeSettings id={id} />}

      <NodePlus
        isRight
        id={id}
        data={data}
        xPos={xPos}
        yPos={yPos}
        isBranch={outgoers.length > 0}
      />

      {!linking && <Linker id={id} xPos={xPos} yPos={yPos} type={"action"} />}
    </Paper>
  );
};

export default ActionNode;
